module.exports = __webpack_public_path__ + "static/media/sampleThunb.05d9c813.png";